import { typography } from '@dixa/tokens';

export const fonts = {
  body: typography.family.default,
  heading: typography.family.default,
  mono: typography.family.code,
};
